import VisaImg from '../../assets/icons/card/visa.svg';
import MastImg from '../../assets/icons/card/mastercard.svg';
import AmeImg from '../../assets/icons/card/ame.svg';
import DiscoverImg from '../../assets/icons/card/discover.svg';
import DinerImg from '../../assets/icons/card/diners.svg';
import JCBImg from '../../assets/icons/card/jcb.svg';
import UnionImg from '../../assets/icons/card/unionpay.svg';

export const CardType = {
  visa: VisaImg,
  mastercard: MastImg,
  'american Express': AmeImg,
  maestro: DiscoverImg,
  discover: DiscoverImg,
  'diners Club': DinerImg,
  jcb: JCBImg,
  unionPay: UnionImg,
};
